module.exports = __webpack_public_path__ + "static/media/priorbank-small.34c89bba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/priorbank-small.png
// module id = 545
// module chunks = 0